import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  ALLOCATION_DOUBLE_BOOKINGS_QUERY_KEY,
  ALLOCATION_DOUBLE_BOOKINGS_URL
} from './queryConstants'

type DoubleBookingsPayload = {
  id: string
  teamMembers: string[]
  startTime?: string
  endTime?: string
}

type UseAllocationDoubleBookings = {
  doubleBookings: (values: DoubleBookingsPayload) => Promise<string[]>
  isDoubleBookingsLoading?: boolean
}

const useAllocationDoubleBookings = (): UseAllocationDoubleBookings => {
  const createFunction = async (values: DoubleBookingsPayload) => {
    const payload: {
      teamMembers: string[]
      startTime?: string
      endTime?: string
    } = {
      teamMembers: values.teamMembers
    }

    // Include updated times if provided (e.g., when checking after a drag operation)
    if (values.startTime) {
      payload.startTime = values.startTime
    }
    if (values.endTime) {
      payload.endTime = values.endTime
    }

    return postJSON({
      url: `${ALLOCATION_DOUBLE_BOOKINGS_URL}/${values.id}`,
      method: 'POST',
      json: payload,
      isRota: true
    })
  }

  const { mutateAsync: createMutation, isLoading: isDoubleBookingsLoading } =
    useMutation<string[], unknown, DoubleBookingsPayload, unknown>(
      [ALLOCATION_DOUBLE_BOOKINGS_QUERY_KEY],
      createFunction
    )

  const doubleBookings = (values: DoubleBookingsPayload): Promise<string[]> =>
    createMutation(values)

  return {
    doubleBookings,
    isDoubleBookingsLoading
  }
}

export default useAllocationDoubleBookings
